import api from './api';

export const healthService = {
  // Get basic health check
  getHealth: async () => {
    try {
      const response = await api.get('/api/health');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get detailed service status
  getStatus: async () => {
    try {
      const response = await api.get('/api/status');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get detailed connection and audio statistics
  getStats: async () => {
    try {
      const response = await api.get('/api/stats');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get companies with active connections
  getCompanies: async () => {
    try {
      const response = await api.get('/api/companies');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get connection statistics (authenticated)
  getConnectionStats: async () => {
    try {
      const response = await api.get('/api/connection_stats');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get connections details
  getConnections: async () => {
    try {
      const response = await api.get('/api/connections');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
}; 